module.exports = __webpack_public_path__ + "img/split_hero_org.468378a9.png";